import SingleItem from "./SingleItem";
import _ from "lodash";
import Pagination from "./Pagination";

export default class Content {
    #$pagination;
    #$items;

    constructor($data) {
        this.#$items = _.get($data, 'data.products', {});
        this.#$pagination = {
            meta: _.get($data, 'meta', {}),
            links: _.get($data, 'links', {}),
        };
    }

    render() {
        return `
            <div class="row mb-3 mx-0 px-res-0">
                ${this.#initItems()}
            </div>
            ${new Pagination(this.#$pagination).render()}
        `
    }

    #initItems() {
        let renderItems = '';
        if (_.isEmpty(this.#$items)) {
            return `<div class="col-xl-12 col-md-12 d-flex justify-content-center align-items-center">
                        <div class="alert alert-custom alert-light-warning shadow text-center fade show my-2 p-4" role="alert">
                            <div class="alert-icon">
                                <i class="fad fa-triangle-exclamation icon-2x"></i>
                            </div>
                            <div class="alert-text">
                                <h5 class="font-weight-bolder">نتیجه‌ای یافت نشد!</h5>
                                <p>از عبارت‌های متداول‌تر استفاده کنید و یا املای عبارت وارد‌شده را بررسی کنید.</p>
                            </div>
                        </div>
                    </div>`;
        }
        this.#$items.forEach((product) => {
            renderItems = renderItems.concat(new SingleItem(product).render())
        })
        return renderItems;
    }
}